<template>
    <div>
        <Support v-if="store.bannerVisible"></Support>
        <div id="footer" ref="footer" v-if="$mq != 'sm'" :class="{ player: store.privatePlayerVisible }">

            <a href="https://radio.montezpress.blog" target="_blank">Blog</a>
            <a href="https://montezpress.com" target="_blank">Press</a>
            <!--
        <form id="donate" target="_blank" action="https://www.paypal.com/cgi-bin/webscr" method="post">
            <input type="hidden" name="cmd" value="_s-xclick" />
            <input type="hidden" name="hosted_button_id" value="CYMT4JLETZ6GW" />
            <input id="donateSubmit" type="submit" value="Donate" />
        </form>
        -->
            <a href="http://instagram.com/montezpressradio" target="_blank">Instagram</a>
            <a href="https://montezpress.us11.list-manage.com/subscribe?u=ad96a1e16c46b57c428adefa3&id=5021009216"
                target="_blank">Newsletter</a>
            <router-link :to="{ name: 'privacy' }">Privacy Policy</router-link>
            <router-link :to="{ name: 'imprint' }">Imprint</router-link>
            <!--
        <div id="spacer"></div>
        <router-link :to="{name: 'subscribe'}">Support Montez Press Radio</router-link>
        -->
        </div>
    </div>
</template>

<script>
import { EventBus } from "../eventBus.js";
import { store } from "../store";
import Support from "./Support.vue";
//import _ from 'lodash';

export default {
    name: "Footer",
    components: {
        Support,
    },
    data() {
        return {
            observer: null,
            store: store,
        };
    },
    watch: {
        "store.valid"(newVal, oldVal) {
            // if (newVal != oldVal && this.$route.name == "archive") {
            if (newVal == true) {
                this.store.bannerVisible = false;
            } else {
                this.store.bannerVisible = true;
            }
            // }
        },
        "$route.name"(newVal, oldVal) {
            if (
                newVal == "archive" ||
                newVal == "detail" ||
                newVal == "streamDetail" ||
                newVal == "subscribe"
            ) {
                this.store.bannerVisible = false;
            } else if (this.store.valid) {
                this.store.bannerVisible = false;
            } else {
                this.store.bannerVisible = true;
            }
        },
    },
    methods: {
        //isScrolledIntoView (el) {
        //let rect = el.getBoundingClientRect()
        //let elemTop = rect.top
        //let elemBottom = rect.bottom
        //let isVisible = elemTop < window.innerHeight && elemBottom >= 0
        //return isVisible
        //},
        //scroll () {
        //let myself = this;
        //window.onscroll = _.throttle(() => {
        //let scrolledTo = document.querySelector('#footer');
        //if (scrolledTo && this.isScrolledIntoView(scrolledTo)) {
        //EventBus.$emit('footer', true)
        //} else {
        //EventBus.$emit('footer', false)
        //}
        //}, 500)
        //}
    },
    created() {
        //let myself = this;
        // this.observer = new IntersectionObserver(
        //     function(entries) {
        //         if (entries[0].isIntersecting == true) {
        //             EventBus.$emit("footer", true);
        //         } else {
        //             EventBus.$emit("footer", false);
        //         }
        //     },
        //     { threshold: [0.1] }
        // );
    },
    mounted: function () {
        if (this.store.valid == true || this.$route.name == "archive") {
            this.store.bannerVisible = false;
        }
        //this.scroll()
        // let myself = this;
        // setTimeout(function() {
        //     myself.observer.observe(myself.$refs.footer);
        // }, 1000);
    },
};
</script>

<style scoped>
#footer {
    padding: 0.7rem 1rem 0.7rem;
    border-top: 1px solid black;
    margin-top: -1px;
    display: flex;
    transition: padding-bottom 0.5s;
}

#footer.player {
    /* padding-bottom: 6.9rem; */
}

#footer>a {
    margin-right: 1rem;
}

#spacer {
    flex-grow: 1;
}

#donate {
    display: inline;
    margin-right: 1rem;
}

#donateSubmit {
    border: none;
    background-color: transparent;
    margin: 0;
    padding: 0;
    cursor: pointer;
    font-family: "Montez Large";
    font-size: 1.333rem;
    color: black;
    display: inline;
    width: auto;
}
</style>
